module.exports = __webpack_public_path__ + "static/media/close-circle.900b014a.svg";